import env from '@/util/env';

const isProduction = env.IS_PRODUCTION;

export async function tryCatch<Data>(
  promise: Promise<Data>
): Promise<null | Data> {
  if (isProduction) {
    try {
      return await promise;
    } catch (error: unknown) {
      console.error(error);
    }
    return null;
  }

  return await promise;
}
